<template>
  <div>
    <vx-card
        class="home-card"
        style="margin-bottom: 20px"
        :id="'vote_card_' + vote.id"
        v-if="vote.status != 4 && vote.type == 'voting'"
    >
        <h4>{{ vote.voting_title }}</h4>
        <h4 class="float-right">
            <event-voting-countdown :key='vote.id' :event_voting_id='vote.id'></event-voting-countdown>
        </h4>
        <br />
        <div :id="'vote_' + vote.id">
            <p>
                <strong>{{ $t("VotingTitle") }}: </strong>
                {{ vote.voting_name }}
            </p>
            <p>
                <strong>{{ $t("VotingDescription") }}: </strong>
                <span v-html="vote.voting_description"></span>
            </p>
            <!-- :id="'hid_btn_' + vote.id" -->
            <div v-if="entered_polling!='YES' && vote.right_to_vote != 0 && vote.status!=2 && vote.allVoted == 0" style="margin-top: 10px">
                <vs-button
                    :disabled='isAdmin'
                    style="font-size: 20px"
                    @click="handleVoting()"
                    >{{ $t("VoteNow") }}
                </vs-button>
            </div>
            <div style="margin-top: 10px" >
                <div v-if="vote.status == 2" style>
                    <vs-button disabled>{{ $t("VotingClosed") }}</vs-button>
                </div>
                <div v-else-if="vote.allVoted != 0 || vote.status == 0">
                    <vs-button :class="vote.allVoted != 0	? 'vs-button-success' : 'vs-button-primary'" disabled>
                        {{ vote.allVoted != 0 ? $t("ThanksForVoting") : $t ("VotingNotOpen")	}}
                    </vs-button>
                </div>
                <!-- <div v-else-if="vote.status == 1 && vote.right_to_vote == 1">
                    <div class></div>
                    <vs-button
                        :disabled='isAdmin'
                        style="font-size: 20px"
                        @click="handleVoting(vote.id, vote.type_of_voting)"
                        >{{ $t("VoteNow") }}
                    </vs-button>
                </div> -->
                <div v-else-if="vote.status == 1 && vote.right_to_vote == 0">
                    <div class></div>
                    <vs-button style="font-size: 20px" disabled
                        >{{ $t("VoteRight") }}
                    </vs-button>
                </div>
                <!-- <div v-else>
                    <div class></div>
                    <vs-button style="font-size: 20px" disabled
                        >{{ $t("VoteRight") }}
                    </vs-button>
                </div> -->
            </div>
            <template v-if="entered_polling=='YES' && vote.status == 1 && !vote.allVoted">
                <!---delegeted_for-->
                <div v-if="event_detail.delegation_vote_preference!='joint' && delegated_for.length > 0">
                    <!-- <template v-if='userVoted.length > 0'>
                        <p v-if="express[vote.id] == '1-' + vote.id">
                            {{ $t("ExpressAllUser") }}
                        </p>
                        <p v-if="express[vote.id] == '2-' + vote.id">
                            {{ $t("ExpressSingleUser") }}
                        </p>
                    </template> -->
                    <!-- userVoted.length < 1 &&  -->
                    <ul
                        style="text-align: left !important"
                        v-if="vote.user_votings.length < 1"
                    >
                        <li>
                            <vs-radio :name="vote.id+'preference'" v-model='vote_preference' vs-value='ALL'>{{ $t("ExpressAllUser") }}
                            </vs-radio>
                        </li>
                        <li>
                            <vs-radio :name="vote.id+'preference'" v-model='vote_preference' vs-value='SINGLE'>{{ $t("ExpressSingleUser") }}
                            </vs-radio>
                        </li>
                    </ul>
                    <br />
                </div>				

                <!--Yes/no type voting-->
                <!-- :id="'vote_yes_' + vote.id" -->
                <div
                    v-if="vote.type_of_voting == 3"
                    style="padding: 10px 0px;"
                >
                    <!---delegeted_for-->
                    <div v-if="delegated_for.length > 0">
                        
                        <div v-if="vote_preference=='SINGLE'">
                            <template v-for="(dele) in nextDelegateForVoting">
                                <div :key="dele.id" class='mb-2'>
                                    <span
                                        >{{ $t("ExpressVoteFor") }}
                                        <strong>{{ dele.first_name }} {{ dele.last_name }}</strong
                                        ><br /><br
                                    /></span>
                                    <event-voting-option :is_secret='vote.is_secret==1' :type_of_voting='vote.type_of_voting' @submit-vote="submitVote($event,dele.delegated_for,'SINGLE')"></event-voting-option>
                                </div>
                            </template>
                        </div>

                        <div v-else-if="vote_preference=='ALL'" :id="'express-all-' + vote.id">
                            <span>{{ $t('ExpressVoteForAllPhrase') }}</span><br /><br/>
                            <event-voting-option :is_secret='vote.is_secret==1' :type_of_voting='vote.type_of_voting' @submit-vote="submitVote($event,null,'ALL')"></event-voting-option>
                        </div>

                    </div>
                    <!--normal flow-->
                    <event-voting-option v-else :is_secret='vote.is_secret==1' :type_of_voting='vote.type_of_voting' @submit-vote='submitVote($event)'></event-voting-option>
                    <br />
                    <br />
                </div>
                <!-- \Yes/no type voting-->

                <!--Candidate type voting-->
                <!-- :id="'vote_candidate_' + vote.id" -->
                <div
                    v-else-if="vote.candidates.length > 0 && vote.type_of_voting == 1"
                    style="padding: 10px 0px;"
                >
                    <div v-if="delegated_for.length > 0">
                        <div v-if="vote_preference=='SINGLE'">
                            <template v-for="(dele) in nextDelegateForVoting">
                                <div :key="dele.id">
                                    <span
                                        >{{ $t("ExpressVoteFor") }}
                                        <strong>{{ dele.first_name }} {{ dele.last_name }}</strong
                                        ><br /><br
                                    /></span>
                                    <event-voting-option :candidate_buttons='vote.candidate_buttons' :is_secret='vote.is_secret==1' :candidates='vote.candidates_' :preference_no="{max:vote.preference_no, min:vote.min_preference_no}" :type_of_voting='vote.type_of_voting' @submit-vote="submitCandidate($event,dele.delegated_for,'SINGLE')"></event-voting-option>
                                    <br/>
                                    <span style="color: red">
                                        <strong ref='candidate_error_SINGLE'></strong>
                                        <br /><br />
                                    </span>
                                </div>
                            </template>
                        </div>
                        <div v-else-if="vote_preference=='ALL'" :id="'express-all-' + vote.id">
                            <span>{{ $t('ExpressVoteForAllPhrase') }}</span><br /><br/>
                            <event-voting-option :candidate_buttons='vote.candidate_buttons' :is_secret='vote.is_secret==1' :candidates='vote.candidates_' :preference_no="{max:vote.preference_no, min:vote.min_preference_no}" :type_of_voting='vote.type_of_voting' @submit-vote="submitCandidate($event,null,'ALL')"></event-voting-option>
                            <br />
                            <span style="color: red">
                                <strong ref='candidate_error_ALL'></strong>
                                <br /><br />
                            </span>
                        </div>
                    </div>
                    
                    <!--normal flow-->
                    <div v-else>
                        <event-voting-option :is_secret='vote.is_secret==1' :candidates='vote.candidates_' :candidate_buttons='vote.candidate_buttons' :preference_no="{max:vote.preference_no, min:vote.min_preference_no}" :type_of_voting='vote.type_of_voting' @submit-vote="submitCandidate($event)"></event-voting-option>
                        <br />
                        <span style="color: red">
                            <strong ref='candidate_error'></strong>
                            <br /><br />
                        </span>
                    </div>
                    <br />
                    <br />
                </div>
                <!-- /Candidate type voting-->

                <!-- Option type voting-->
                <!-- :id="'vote_option_' + vote.id" -->
                <div
                    v-else-if="vote.type_of_voting == 2 && vote.options.length > 0 && entered_polling=='YES'"
                    style="padding: 10px 0px;"
                >
                    <div v-if="delegated_for.length > 0">
                        <template v-if="vote_preference=='SINGLE'">
                            <template v-for="(dele) in nextDelegateForVoting">
                                <div :key="dele.id">
                                    <span
                                        >{{ $t("ExpressVoteFor") }}
                                        <strong>{{ dele.first_name }} {{ dele.last_name }}</strong
                                        ><br /><br
                                    /></span>
                                    <event-voting-option :is_secret='vote.is_secret==1' :options='vote.options' :preference_no="{max:vote.preference_no, min:vote.min_preference_no}" :type_of_voting='vote.type_of_voting' @submit-vote="submitOptions($event,dele.delegated_for,'SINGLE')"></event-voting-option>
                                </div>
                            </template>
                        </template>

                        <div v-else-if="vote_preference=='ALL'" :id="'express-all-' + vote.id">
                            <span>{{ $t('ExpressVoteForAllPhrase') }}</span><br /><br/>
                            <event-voting-option :is_secret='vote.is_secret==1' :options='vote.options' :preference_no="{max:vote.preference_no, min:vote.min_preference_no}" :type_of_voting='vote.type_of_voting' @submit-vote="submitOptions($event,null,'ALL')"></event-voting-option>
                        </div>
                    </div>
                    <!--normal flow-->
                    <div v-else>
                        <event-voting-option :is_secret='vote.is_secret==1' :options='vote.options' :preference_no="{max:vote.preference_no, min:vote.min_preference_no}" :type_of_voting='vote.type_of_voting' @submit-vote="submitOptions($event)"></event-voting-option>
                    </div>
                    <br />
                    <br />
                </div>
                <!--\Option type voting-->

                <!-- Free Text type Voting -->
                <!-- :id="'vote_freetext_' + vote.id" -->
                <div
                    v-else-if="vote.type_of_voting == 4"
                    style="padding: 10px 0px;"
                >
                    <div v-if="delegated_for.length > 0">
                        
                        <div v-if="vote_preference=='SINGLE'">
                            <template v-for="(dele) in nextDelegateForVoting">
                                <div :key="dele.id">
                                    <span>{{ $t("ExpressVoteFor") }}
                                        <strong>{{ dele.first_name }} {{ dele.last_name }}</strong
                                        ><br /><br/>
                                    </span>
                                    <vs-button v-if="userVoted.includes(dele.delegated_for)" disabled>{{ $t("ThanksForVoting") }}</vs-button>
                                    <event-voting-option v-else :is_secret='vote.is_secret==1' :candidates='vote.candidates' :preference_no="{max:vote.preference_no, min:vote.min_preference_no}" :type_of_voting='vote.type_of_voting' @submit-vote="submitFreeText($event.payload, $event.presentNotVoting, dele.delegated_for,'SINGLE')"></event-voting-option>
                                </div>
                            </template>
                        </div>
                        <div v-else-if="vote_preference=='ALL'" :id="'express-all-' + vote.id">
                            <span>{{ $t('ExpressVoteForAllPhrase') }}</span><br /><br/>
                            <event-voting-option :is_secret='vote.is_secret==1' :candidates='vote.candidates' :preference_no="{max:vote.preference_no, min:vote.min_preference_no}" :type_of_voting='vote.type_of_voting' @submit-vote="submitFreeText($event.payload, $event.presentNotVoting,null, 'ALL')"></event-voting-option>
                            <span style="color: red">
                                <strong ref='candidate_error_ALL'></strong>
                                <br /><br />
                            </span>
                        </div>
                    </div>
                    <!--normal flow-->
                    <event-voting-option v-else :is_secret='vote.is_secret==1' :candidates='vote.candidates' :preference_no="{max:vote.preference_no, min:vote.min_preference_no}" :type_of_voting='vote.type_of_voting' @submit-vote="submitFreeText($event.payload, $event.presentNotVoting)"></event-voting-option>
                    
                    <br />
                    <br />
                </div>
                <!-- \Free Text type Voting -->
            </template>
        </div>
    </vx-card>
    <vx-card
        class="home-card"
        style="margin-bottom: 20px"
        v-else-if="vote.type == 'agenda'"
    >
        <p class="mb-2">
            <strong>{{ vote.title }}</strong>
        </p>
        <p class="mb-2">
            <strong>Topic: </strong>
            {{ vote.name }}
        </p>
        <p class="mb-1">
            <strong>Description: </strong>
            <span v-html="vote.description"></span>
        </p>
        <div v-if="vote.attachment != null">
            <div class="float-right">
                <strong>Attachments: </strong>
                <div
                    v-for="(attach, index2) in vote.attachment.split(',')"
                    :key="index2"
                >
                    <a :href="event_detail.event_agenda_path + '/' + vote.id + '/' + attach"
                        type="download"
                        target="_blank"
                    >{{ attach }}</a>
                </div>
            </div>
            <div style="clear: both"></div>
        </div>
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
    name: 'Ev',
	props: ['voting'],
    data: () => ({
        // astenutoIds: [],
        // astenuto: [],
        identifier: '',
        get entered_polling() {
            return sessionStorage.getItem(`${this.identifier}-ep`) || 0; 
        },
        set entered_polling(value) {
            sessionStorage.setItem(`${this.identifier}-ep`, value.toUpperCase());
        },
        get vote_preference() {
            return sessionStorage.getItem(`${this.identifier}-pref`) || 0;  
        },
        set vote_preference(value) {
            sessionStorage.setItem(`${this.identifier}-pref`, value.toUpperCase());
        }
    }),
    components: { 
        EventVotingCountdown: () => import('./event-voting-countdown'),
		EventVotingOption: () => import('./event-voting-option'),
    },
	computed: {
        ...mapGetters([
			"myself",
            "event_detail",
            "ipAddress"
		]),
        delegated_for() {
            return this.$store.state.event.delegated_for;
        },
        confirmation_vote() {
			return this.$store.state.event.confirmation_vote;
		},
        isAdmin() {
			return this.myself && (this.myself.user_role=='admin' || this.myself.user_role=='admin_observer')
		},
        nextDelegateForVoting() {
            const vote = this.vote;
			return this.delegated_for
			.filter(dele => vote.delegatedForUserIds.includes(dele.id) && !this.userVoted.includes(parseInt(dele.delegated_for)))
			.filter((m,n) => n==0);		
		},
        userVoted() {
			return this.vote.user_votings.map(uv => uv.user_id ? uv.user_id : uv.id);
		},
		vote() {
            if(!this.voting)
                return {};
            const isSmallDevice = window.screen.availWidth < 960;
            const evote = {...this.voting};
			// evote.voting_no = i;
            evote.allVoted = null;
            if(evote.type == 'agenda')
                return evote;
            evote.user_votings = typeof evote.user_votings == 'undefined' ? [] : evote.user_votings;
            const user_voting = evote.user_votings.map((voted) =>
                voted.user_id ? voted.user_id : voted.id
            );
            if (this.delegated_for.length > 0) {
                console.log(evote.delegatedForUserIds, user_voting)
                evote.allVoted = evote.delegatedForUserIds
                .every((dfui) =>
                    user_voting.includes(dfui)
                ) ? 1 : 0;
            } else
                evote.allVoted = user_voting.includes(this.myself.id) ? 1 : 0;

            const candidates_ = [[], []]; // [ odd, even ]
            evote.candidates = typeof evote.candidates == "undefined" ? [] : evote.candidates;
            const candidates = evote.candidates.filter(c => c.is_button==0 || c.is_button==false);

            if(isSmallDevice || candidates.length < 40) {
                candidates_[0] = [...candidates];
            } else {
                candidates.forEach((candidate, cdx) => {
                    candidates_[(cdx+1)%2==0?1:0].push(candidate);
                });
            }

            evote.candidates_ = candidates_;
            evote.candidate_buttons = evote.candidates.filter(c => c.is_button==1 || c.is_button==true);
            evote.options = typeof evote.options == "undefined" ? [] : evote.options;
            return evote;
		}
	},
    created() {
        if(this.event_detail && this.voting)
			this.identifier = `${(new Date(this.event_detail.updated_at)).getTime()}-${this.myself.id}${this.event_detail.id}${this.voting.id}`;
        if(this.event_detail.delegation_vote_preference=='joint')
            this.vote_preference = 'ALL';
    },
    methods: {
        
        getEventStatus(end_voting_id = null) {
			this.$store.commit('UPDATE_EVENT_LISTENER', {key: 'EventStatus', payload: end_voting_id});
		},
        /**
		 * Handle Voting
		 * @author Taherali Sonkachwala
		 */
		handleVoting() {
			this.entered_polling = 'YES';
            // const vote = this.vote;
			// var index = vote.candidates.findIndex(function(obj) {
			// 	return obj.candidate_name.toLowerCase().replace(/\s/g, '') == 'astenuto'
			// });
			// let val = false
			// if(vote.is_secret == 1 && vote.type_of_voting == 1 && index > -1){
			// 	const idIndex = this.astenuto.indexOf(vote.id);
			// 	if(idIndex == -1)
			// 		this.astenuto.push(vote.id)
			// 	const candIndex = this.astenutoIds.findIndex(function(obj) {
			// 		return obj.id == vote.candidates[index].id
			// 	});
			// 	if(candIndex == -1){
			// 		this.astenutoIds.push({vote_id: vote.id, candidate_id: vote.candidates[index].id})
			// 	}
			// }

			this.$nextTick(function() {
				if (!this.delegated_for.length > 0) 
					this.singleUserVote(false);
				this.loggedIn();
			})
		},

        /**
		 * express vote
		 * @author Taherali Sonkachwala
		 */
		singleUserVote(value) {
            this.vote_preference = value ? 'SINGLE' : 'ALL'
		},

        /**
		 * Mark as present for event
		 * @author Madhura Shah
		 */
		async loggedIn() {
			var data = {
				user_id: this.myself.id,
				event_id: this.event_detail.id,
				voting_id: this.voting.id,
			};
			try {
				await this.$store.dispatch("loggedIn", data);
			} catch (error) {
				this.$log.error(
					"File : Event.vue | Function : loggedIn() | Error :",
					error
				);
				this.$vs.loading.close();
				// Error response
				this.$vs.notify({
					title: this.$t("EventLoggedError"),
					text: error,
					color: "danger",
					position: "top-center",
				});
			}
		},

        /**
		 * option voting
		 * @author Madhura Shah
         * @params option any selected option
         * @params type string SINGLE | ALL
         * @params userId integer
		 */
		async submitOptions(option,userId = null, type=null) {
            if(type == null)
			    userId = userId ? userId : this.myself.id;

            const data = {
				user_id: userId,
				event_voting_id: this.vote.id,
				options: [option.id],
				ip_address: this.ipAddress,
				voted_by: this.myself.id,
				is_delegated: userId == this.myself.id ? 0 : 1,
                type: type
				// express: this.express[id],
			};

			if (this.confirmation_vote == 1) {
				const textConfirm = `${this.$t("YouAreVoting")}${option.options} ${this.$t("To")} ${this.vote.voting_name}.`;

				const result = await this.$swal({
					title: textConfirm,
					text: this.$t("Confirm"),
					type: "warning",
					showCancelButton: true,
					confirmButtonText: this.$t("IConfirm"),
					confirmButtonColor: "#7367F0",
					cancelButtonText: this.$t("Cancel"),
					showCloseButton: true,
					showLoaderOnConfirm: true,
				})

                if (result.value) 
                    this.addVoting(data);
                
				
			} else 
				this.addVoting(data);
		},

        /**
		 * Submit vote
		 * @author Madhura Shah
		 */
		async submitVote(value,userId = null,type=null) {
            if(type == null)
			    userId = userId ? userId : this.myself.id;
            const data = {
				user_id: userId,
				event_voting_id: this.vote.id,
				yes_or_no: value,
				ip_address: this.ipAddress,
				voted_by: this.myself.id,
				is_delegated: userId == this.myself.id ? 0 : 1,
                type:type
			};
			if (this.confirmation_vote == "1") {
				// this.currentExpressVote = this.express[this.vote.id];

				let statusText;
				if (value == 0) {
					statusText = this.$t("No");
				} else if (value == 1) {
					statusText = this.$t("Yes");
				} else {
					statusText = this.$t("Abstained");
				}
				let textConfirm = `${this.$t("YouAreVoting")}${statusText} ${this.$t("To")} ${this.vote.voting_name}.`;
				const result = await this.$swal({
					title: textConfirm,
					text: this.$t("Confirm"),
					type: "warning",
					showCancelButton: true,
					confirmButtonText: this.$t("IConfirm"),
					confirmButtonColor: "#7367F0",
					cancelButtonText: this.$t("Cancel"),
					showCloseButton: true,
					showLoaderOnConfirm: true,
				})
                // data.express = this.currentExpressVote,
                if (result.value) 
                    this.addVoting(data);
                
			} else
				this.addVoting(data);
		},

        /**
		 * candidate voting
		 * @author Madhura Shah
		 */
		async submitCandidate(values, userId = null, type =null) {
            const id = this.vote.id;
            const preference_no = this.vote.preference_no;

            if(type == null)
			    userId = userId ? userId : this.myself.id;

			let errorSelector = this.$refs.candidate_error;
			if (type != "" && type != null && typeof type != 'undefined') 
				errorSelector = this.$refs[`candidate_error_${type}`];
			
			if(values.length < 1)
				errorSelector.innerText = this.$t("VotingNoCandidateSelected")
			else if(values.length > preference_no) 
				errorSelector.innerText = `${this.$t("VotingPreferencesError")} ${preference_no} ${this.$t("Preferences")}`;
			else {
				errorSelector.innerText = "";
				// this.currentExpressVote = this.express[id];
				const req = {
                    type:type,
					user_id: userId,
					event_voting_id: id,
					candidates: values,
					ip_address: this.ipAddress,
					voted_by: this.myself.id,
					is_delegated: userId == this.myself.id ? 0 : 1,
					// express: this.express[id],
				};
				this.addVoting(req);
			}
		},

        async addVoting(payload) {
            this.$vs.loading();
            try{
                await this.$store.dispatch("addUserVoting", payload)
                this.getEventStatus(this.vote.id);
                this.$vs.notify({
                    color: "success",
                    text: this.$t("VoteSubmitted"),
                    position: "top-center",
                });
            }catch(error) {
                this.$log.error(
                    "File : Event.vue | Function : addVoting() | Error :",
                    error
                );
                // Error response
                this.$vs.notify({
                    title: this.$t("VoteSubmitError"),
                    text: error,
                    color: "danger",
                    position: "top-center",
                });
            }
            this.$vs.loading.close();
        },

        async submitFreeText(values,presentNotVoting = false,userId = null,type=null) {
            if(type == null)
			    userId = userId ? userId : this.myself.id;
                
            // this.currentExpressVote = this.express[id];

			const data = {
				user_id: userId,
				event_voting_id: this.voting.id,
				freeTextValues: values.filter(Boolean),
				ip_address: this.ipAddress,
				voted_by: this.myself.id,
				is_delegated: userId == this.myself.id ? 0 : 1,
				// express: this.express[id],
				presentNotVoting: presentNotVoting ? 1 : 0,
                type:type
			};
            this.addVoting(data);
		},
    }
}
</script>

<style>

</style>